import { EVENT_PAGE_SIZE } from "../../pages/recent-activities/utils/constants";

export interface BuildEventQueryVariablesInput {
  customerId: string;
  facilityId?: string;
  modelId?: string;
  deviceId?: string;
  eventTimestamp?: string;
  fromDate?: string;
  toDate?: string;
  pageSize?: number;
  lastEvaluatedKey?: string;
}

export const buildEventQueryVariables = ({
  customerId,
  facilityId = "",
  modelId = "",
  deviceId = "",
  eventTimestamp = "",
  fromDate = "",
  toDate = "",
  pageSize = EVENT_PAGE_SIZE,
  lastEvaluatedKey,
}: BuildEventQueryVariablesInput) => {
  return {
    customerId: encodeURIComponent(customerId),
    facilityId: encodeURIComponent(facilityId.split("L#").at(-1) ?? ""),
    modelId,
    deviceId,
    eventTimestamp,
    fromDate,
    toDate,
    pageSize,
    ...(lastEvaluatedKey
      ? { lastEvaluatedKey: encodeURI(JSON.stringify(lastEvaluatedKey)) }
      : { lastEvaluatedKey: "" }),
  };
};
